import TWalkthroughIvrUserGroup from './index.vue';

TWalkthroughIvrUserGroup.install = app => {
  app.component(TWalkthroughIvrUserGroup.name, TWalkthroughIvrUserGroup);
};

export default TWalkthroughIvrUserGroup;
